import checkEnvironment from '../checkEnvironment';

const getSessionDetailsApiUrl = (requestAccessKey, userKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/privilegedinstance/sessions/${requestAccessKey}?userkey=${userKey}`;
};

export default getSessionDetailsApiUrl;
